import { PosApiEventListener } from "./types";

export const LINKLY_STORAGE_KEY = "__linkly__";

export const DEFAULT_POS_STATE = {
  isPaired: false,
  isPairing: false,
};

export const PAIR_SECRET_STORAGE_KEY = "pairSecret";
export const TOKEN_STORAGE_KEY = "token";
export const TOKEN_EXPIRY_STORAGE_KEY = "tokenExpiry";

export const PAIRING_ENDPOINT = "/v1/pairing/cloudpos";
export const TOKEN_REQUEST_ENDPOINT = "/v1/tokens/cloudpos";
export const TRANSACTION_ENDPOINT = "/v2/sessions/{0}/transaction";
export const RESULT_ENDPOINT = "/v2/sessions/{0}/result?all={1}";
export const SEND_KEY_ENDPOINT = "/v2/sessions/{0}/sendkey";
export const LINKLY_ENDPOINT = "/v1/sessions/";
export const STATUS_ENDPOINT = "/v2/sessions/{0}/status";
export const REPRINT_RECEIPT_ENDPOINT = "/v2/sessions/{0}/reprintreceipt";

export const noop = () => {};

export const noopApiEventListener: PosApiEventListener = {
  onReceipt: noop,
  onDisplay: noop,
  onError: noop,
  onTransactionComplete: noop,
  onPairingComplete: noop,
  onStatusCompleted: noop,
  onReceiptReprintComplete: noop,
  onResultComplete: noop,
  onTransactionStatusRequestComplete: noop,
};

export const UiConstants = {
  Ok: "Ok",
  OkCancelKey: "0",
  Cancel: "CANCEL",
  Yes: "YES",
  YesKey: "1",
  No: "NO",
  NoKey: "2",
  Authorise: "AUTHORISE",
  AuthoriseKey: "3",
  fixed: "Fixed",
  Percentage: "Percentage",
};

export const PurchaseAnalysisData = {
  // Transaction reference number to be provided to follow-up transaction requests and returned
  // in the transaction response for some initial request types, eg: purchase.
  RFN: "RFN",

  //Full transaction amount after tipping and surcharges, returned in a transaction response.
  Amount: "AMT",

  // Surcharge amount (in cents), returned in a transaction response
  Surcharge: "SUR",

  // Pre-auth index to request, for use in a pre-auth summary request.
  PAI: "PAI",

  // Cardholder tipping options, for use in a transaction request.
  TPO: "TPO",

  // Tip amount (in cents) to apply on top of the transaction amount, for use in a transaction
  // request.
  Tip: "TIP",

  // Surcharge options to apply based on card bin, for use in a transaction request.
  SC2: "SC2",

  // Indicate whether a restricted item is present in the sale, for use in a transaction request.
  PLB: "PLB",
};
